module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.f2dc9377.jpg";